import React from 'react';
import { Button } from './ui/button';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img 
              src="/valoryx-logo.png" 
              alt="VALORYX" 
              className="h-10"
            />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-600 hover:text-primary transition-colors duration-200"
            >
              Leistungen
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-gray-600 hover:text-primary transition-colors duration-200"
            >
              Vorteile
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-600 hover:text-primary transition-colors duration-200"
            >
              Kontakt
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-primary hover:bg-primary/90 transition-colors duration-200"
            >
              Beratung anfragen
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;